module.exports = __webpack_public_path__ + "static/media/ensIconLogo.4d995d23.svg";